import { createAction, props } from '@ngrx/store';

import { FormState } from '@shared/form/store/form.reducer';

export const formOpen = createAction(
  '[Form] Open',
  props<{ formState: FormState }>()
);

export const formClose = createAction(
  '[Form] Close',
  props<{ payload?: any }>()
);

export const formSubmit = createAction(
  '[Form] Submit',
  props<{ redirectUrl?: string }>()
);
